import FacturesController from './factures.controller';
import FactureTpl from './factures.tpl.html';

export default {
	template: FactureTpl,
	controller: FacturesController
};
